module.exports = __webpack_public_path__ + "static/media/rundkolben_antwort3.0270039d.png";